import { render, staticRenderFns } from "./ModificaOggetto.vue?vue&type=template&id=f4bac50e&scoped=true&"
import script from "./ModificaOggetto.vue?vue&type=script&lang=js&"
export * from "./ModificaOggetto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bac50e",
  null
  
)

export default component.exports